var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Line, Text } from 'elemental-react';
import { Platform } from 'react-primitives';
var TextInput = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, error = _a.error, _b = _a.value, value = _b === void 0 ? '' : _b, children = _a.children, isFocused = _a.isFocused, _c = _a.focusedColor, focusedColor = _c === void 0 ? '#F4B728' : _c, _d = _a.lineColor, lineColor = _d === void 0 ? '#000000' : _d, props = __rest(_a, ["label", "placeholder", "error", "value", "children", "isFocused", "focusedColor", "lineColor"]);
    return (_jsxs(Box, __assign({ name: "TextInputBox", height: 24 }, { children: [_jsx(Text, __assign({ as: Platform.OS === 'web' ? 'input' : undefined, name: "TextInput", fontSize: 18, fontFamily: "secondary", mb: "6px", color: !value ? 'greys.8' : undefined, children: Platform.OS !== 'web' ? (value || placeholder || label) : undefined, 
                // @ts-ignore
                placeholder: Platform.OS === 'web' && !value ? (placeholder || label) : undefined, value: Platform.OS === 'web' && value }, props), void 0), _jsx(Line, { height: 1, width: "100%", bg: isFocused ? focusedColor : lineColor }, void 0)] }), void 0));
};
export default TextInput;
